import { render, staticRenderFns } from "./RegisterAuth.vue?vue&type=template&id=6139d46b&scoped=true&"
import script from "./RegisterAuth.vue?vue&type=script&lang=js&"
export * from "./RegisterAuth.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAuth.vue?vue&type=style&index=0&id=6139d46b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139d46b",
  null
  
)

export default component.exports